import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'lineBreak',
})
export class LineBreakPipe implements PipeTransform {
  transform(value: string) {
    if (!value || !value.length) { return value; }
    return value.replace(/(\\r\\n)|([\r\n])/gmi, '<br/>');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/line-break/line-break.ts